import { PresetsState } from "@/app/slices/presetsSlice";
import { localeSelector } from "@/utils";
import { parseUnknownDate } from "@/utils/ensureUTC";
import { useMediaQuery } from "@uidotdev/usehooks";
import { formatInTimeZone } from "date-fns-tz";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const Dater = ({
  children,
  format,
  showTime = true,
}: {
  children: any;
  format?: string;
  showTime?: boolean;
}) => {
  const isXS = useMediaQuery("(max-width:1064px)");
  const { i18n } = useTranslation();

  const { timezone } = useSelector<any, PresetsState>((state) => state.presets);

  return children ? (
    <>
      {formatInTimeZone(
        parseUnknownDate(children) as any,
        timezone || "America/Mexico_City",
        format ||
          (showTime
            ? isXS
              ? "MMM dd, HH:mm"
              : "dd MMM yy, HH:mm:ss"
            : isXS
              ? "MMM dd"
              : "dd MMM yy"),
        { locale: localeSelector(i18n.language) },
      )}
    </>
  ) : (
    <>{"—"}</>
  );
};
